import { Pipe, PipeTransform } from '@angular/core';
import { formatsWithTransparency } from '../consts';

@Pipe({
  name: 'assetSupportsTransparency',
  standalone: true,
})
export class AssetSupportsTransparencyPipe implements PipeTransform {
  transform(name: string): boolean {
    if (!name) return false;
    const extension = name.split('.').pop().toLowerCase();
    return formatsWithTransparency.includes(extension);
  }
}
